import { energySystemCollection } from '@/reducers/energySystems'
import { EnergySystem } from '@/types/energySystem'
import { SuggestionCardProps } from '../DeviceSuggestionCard'
import { useDataAndSetLoadedState } from '../../hooks/useDataAndSetLoadedState'

export type Props = SuggestionCardProps & {
  energySystemId: EnergySystem['id']
}

export function useLoadData(props: Props) {
  const { data: energySystems, isLoadingOrIdle } =
    energySystemCollection.useFetch('energy-systems')
  const energySystem = energySystems.find(
    (energySystem) => energySystem.id === props.energySystemId,
  )

  return {
    data: {
      energySystem,
    },
    isLoadingOrIdle,
  }
}

export default function useViewModel(props: Props) {
  const { articles } = props
  const { data, isLoadingOrIdle } = useDataAndSetLoadedState({
    useLoader: useLoadData,
    props,
    setLoadedSignal: props.setLoadedSignal,
  })

  return {
    displayName: data.energySystem?.name ?? '',
    isLoadingOrIdle,
    articles,
  }
}
